import { formatearMoneda } from "../../config/moneda";

const IndicadorVenta = ({ etiqueta, valor, moneda = true, destacado = false }) => (
  <article className={`ventas-kpi${destacado ? " ventas-kpi--destacado" : ""}`}>
    <span>{etiqueta}</span>
    <strong>{moneda ? formatearMoneda(valor) : typeof valor === "string" ? valor : Number(valor || 0).toLocaleString("es-AR")}</strong>
  </article>
);

const VentasKpis = ({ resumen }) => {
  if (!resumen) return null;
  const variacion = `${Number(resumen.VariacionPorcentual || 0).toLocaleString("es-AR")}%`;

  return (
    <section className="ventas-resumen" aria-labelledby="ventas-resumen-titulo">
      <div className="ventas-resumen-titulo">
        <div><span className="ventas-eyebrow">Resumen</span><h3 id="ventas-resumen-titulo">Resultados del período</h3></div>
      </div>
      <div className="ventas-kpis ventas-kpis--principales">
        <IndicadorVenta etiqueta="Venta neta" valor={resumen.VentaNeta} destacado />
        <IndicadorVenta etiqueta="Ventas" valor={resumen.CantidadVentas} moneda={false} destacado />
        <IndicadorVenta etiqueta="Ticket promedio" valor={resumen.TicketPromedio} destacado />
        <IndicadorVenta etiqueta="Variación" valor={variacion} moneda={false} destacado />
      </div>
      <div className="ventas-kpis-secundarios" aria-label="Otros totales del período">
        <IndicadorVenta etiqueta="Venta bruta" valor={resumen.VentaBruta} />
        <IndicadorVenta etiqueta="Descuentos" valor={resumen.Descuentos} />
        <IndicadorVenta etiqueta="IVA" valor={resumen.Iva} />
        <IndicadorVenta etiqueta="Total facturado" valor={resumen.TotalFacturado} />
        <IndicadorVenta etiqueta="Unidades" valor={resumen.UnidadesVendidas} moneda={false} />
        <IndicadorVenta etiqueta="Período anterior" valor={resumen.VentaNetaPeriodoAnterior} />
      </div>
    </section>
  );
};

export default VentasKpis;
